namespace Ir.Components.Email.SendEmailNow {
    interface IViewModel {
        emailOptions: DevExpress.ui.dxTextBox.Properties;
        emailComponent: DevExpress.ui.dxTextBox;
        emailValidator: DevExpress.ui.dxValidator.Properties;
        emailValidatorComponent: DevExpress.ui.dxValidator;

        subjectOptions: DevExpress.ui.dxTextBox.Properties;
        subjectComponent: DevExpress.ui.dxTextBox;
        subjectValidator: DevExpress.ui.dxValidator.Properties;
        subjectValidatorComponent: DevExpress.ui.dxValidator;

        bodyOptions: DevExpress.ui.dxTextArea.Properties;
        bodyComponent: DevExpress.ui.dxTextArea;

        formatOptions: DevExpress.ui.dxSelectBox.Properties;
        formatComponent: DevExpress.ui.dxSelectBox;

        pdfTemplateOptions: DevExpress.ui.dxSelectBox.Properties;
        pdfTemplateComponent: DevExpress.ui.dxSelectBox;
        pdfTemplates: Array<PdfTemplate>;

        suppressReportHeaderOptions: DevExpress.ui.dxSwitch.Properties;

        sendEmailViewModel: SendEmailNowViewModel;
        activeTab: KnockoutObservable<WorkbookTab>;
    }
    interface IParams {
        activeTab: KnockoutObservable<WorkbookTab>;
        getComponent: (obj) => void;
    }

    export function getViewModel(this: IViewModel, params: IParams) {
        let self = this;
        this.activeTab = params.activeTab;
        if (params.getComponent) {
            params.getComponent({
                sendEmail: function () {
                    send(self);
                }
            });
        }

        this.sendEmailViewModel = new SendEmailNowViewModel();

        this.emailOptions = {
            labelMode: "outside",
            label: "Email",
            value: this.sendEmailViewModel.email as any,
            onInitialized(e) {
                self.emailComponent = e.component;
            }
        };
        this.emailValidator = {
            validationRules: [{
                type: 'required',
                message: 'Email is required',
            }, {
                type: "custom",
                message: "Invalid email",
                validationCallback(e) {
                    const value = e.value;
                    if (e.value === undefined || e.value === null) {
                        return false;
                    }

                    if (e.value.trim() === "") {
                        return false;
                    }

                    //.filter(Boolean) remove empty strings
                    const emails = value.split(/[,;]+/).map(email => email.trim()).filter(Boolean);

                    return emails.every(isValidEmail);
                }
            }],
            onInitialized(e) {
                self.emailValidatorComponent = e.component;
            }
        };

        this.subjectOptions = {
            labelMode: "outside",
            label: "Subject",
            value: this.sendEmailViewModel.subject as any,
            onInitialized(e) {
                self.subjectComponent = e.component;
            }
        };
        this.subjectValidator = {
            validationRules: [{
                type: 'required',
                message: 'Subject is required',
            }],
            onInitialized(e) {
                self.subjectValidatorComponent = e.component;
            }
        };

        this.bodyOptions = {
            labelMode: "outside",
            label: "Body",
            height: 65,
            value: this.sendEmailViewModel.body as any,
            onInitialized(e) {
                self.bodyComponent = e.component;
            }
        }

        this.formatOptions = {
            labelMode: "outside",
            label: "Format",
            valueExpr: "id",
            displayExpr: "name",
            dataSource: SendEmailNowViewModel.getFormatDataSource(!this.activeTab, this.activeTab?.() ? this.activeTab().tabType() === TabTypeEnum.Dashboard : false, this.activeTab?.()),
            value: this.sendEmailViewModel.format,
            onInitialized(e) {
                self.formatComponent = e.component;
            },
            onValueChanged(e) {
                if (e.value !== EmailFormatEnum.PDF && e.value !== EmailFormatEnum.PDFLandscape) {
                    self.sendEmailViewModel.pdfTemplate(0);
                }
            }
        };

        this.pdfTemplateOptions = {
            labelMode: "outside",
            label: "PDF Template",
            valueExpr: "id",
            displayExpr: "name",
            dataSource: PDFTemplatesService.getPDFTemplates(false, workbook.workbookConfig.mappingId, true),
            value: this.sendEmailViewModel.pdfTemplate,
            disabled: ko.computed(() => {
                return self.sendEmailViewModel.suppressReportHeader() || (self.sendEmailViewModel.format() !== EmailFormatEnum.PDF && self.sendEmailViewModel.format() !== EmailFormatEnum.PDFLandscape)
            }) as any,
            onInitialized(e) {
                self.pdfTemplateComponent = e.component;
            },
            onValueChanged(e) {
                if (e.value > 0) {
                    self.sendEmailViewModel.suppressReportHeader(false);
                }
            }
        };

        this.suppressReportHeaderOptions = {
            value: this.sendEmailViewModel.suppressReportHeader as any,
            disabled: ko.computed(() => {
                return self.sendEmailViewModel.pdfTemplate() !== 0;
            }) as any,
            onValueChanged(e) {
                if (e.value) {
                    self.sendEmailViewModel.pdfTemplate(0);
                }
            }
        };
    }

    function send(self: IViewModel) {
        let subjectValidator = self.subjectValidatorComponent.validate();
        let emailValidator = self.emailValidatorComponent.validate();
        if (!subjectValidator.isValid || !emailValidator.isValid) {
            return;
        }

        let o = {
            url: urlConfigs.email + "SendSingle",
            data: {
                mappingId: workbook.workbookConfig.mappingId,
                workbookId: workbook.workbookConfig.workbookId(),
                tabId: self.activeTab?.() ? self.activeTab().id() : 0,
                formats: self.sendEmailViewModel.format(),
                bodyText: self.sendEmailViewModel.body(),
                email: self.sendEmailViewModel.email(),
                subjectText: self.sendEmailViewModel.subject(),
                scope: self.activeTab?.() ? self.activeTab().tabType() === TabTypeEnum.Dashboard ? ContainerScopeEnum.Dashboard : ContainerScopeEnum.Report : ContainerScopeEnum.Workbook,
                pdfTemplateId: self.sendEmailViewModel.pdfTemplate(),
                suppressReportHeader: self.sendEmailViewModel.suppressReportHeader()
            },
            dataType: "json",
            async: true
        } as RequestServerParams;
        o.successFunction = function (result, e) {
            let errorMessage = "";
            if (result.resultEmailSent) {
                if (result.resultEmailSent.reportMessage && result.resultEmailSent.reportMessage !== "") {
                    errorMessage = result.resultEmailSent.reportMessage;
                    errorMessage += "<br />";
                }

                result.resultEmailSent.emailsMessage.forEach(function (emailError) {
                    if (!emailError.item1 && emailError.item2 && emailError.item2 !== "") {
                        errorMessage += "Error: " + emailError.item2;
                        errorMessage += "<br />";
                        errorMessage += "Recipients: " + emailError.item3;
                        errorMessage += "<br />";
                        errorMessage += "<br />";
                    }
                });
            }
            else {
                errorMessage = result.error;
            }

            if (errorMessage && errorMessage !== "") {
                showErrorPopup(errorMessage);
            }
            else {
                DevExpress.ui.notify({
                    message: "Email Sent",
                    position: {
                        my: "center top",
                        at: "center top"
                    }
                }, "success", 3000);
            }
        };
        o.failureFunction = function (textStatus, errorThrown, errorItem: IError) {
            errorItem.userMessage = "Failed to send email";
            irGlobal.defaultErrorFunction(errorItem.userMessage, textStatus, errorThrown);
        };

        irGlobal.requestServer(o);

        popupComponent.hide();
    }

    let popupComponent: DevExpress.ui.dxPopup;
    export function show(activeTab: KnockoutObservable<WorkbookTab>) {
        if (popupComponent) {
            let element = popupComponent.element();
            popupComponent.dispose();
            element.remove();
        }

        let sendEmail: Function = null;
        let getComponent = function(obj) {
            sendEmail = obj.sendEmail;
        }

        let popupOptions = {
            maxWidth: '100%',
            width: 500,
            maxHeight: '100%',
            height: 410,
            showTitle: true,
            title: "Send Email",
            dragEnabled: true,
            resizeEnabled: true,
            hideOnOutsideClick: true,
            deferRendering: true,
            showCloseButton: true,
            toolbarItems: [{
                widget: "dxButton",
                toolbar: "bottom",
                location: "after",
                options: {
                    stylingMode: 'contained',
                    text: 'Send',
                    template: `<i class="ms">send</i> Send`,
                    type: 'default',
                    onClick(e) {
                        sendEmail();
                    }
                }
            }, {
                widget: "dxButton",
                toolbar: "bottom",
                location: "after",
                options: {
                    text: 'Close',
                    icon: 'remove',
                    stylingMode: 'outlined',
                    type: 'normal',
                    onClick() {
                        popupComponent.hide();
                    }
                }
            }],
            onInitialized(e) {
                popupComponent = e.component;
                popupComponent.show();
            }
        } as DevExpress.ui.dxPopup.Properties;

        let $popover = $(`
            <div data-bind="dxPopup: popupOptions">
                <send-emailnow params="activeTab: activeTab, getComponent: getComponent"></send-emailnow>
            </div>`);
        $popover.appendTo('body');

        ko.applyBindings({ popupOptions, activeTab, getComponent }, $popover[0]);
    }

    let errorPopupComponent: DevExpress.ui.dxPopup;
    function showErrorPopup(errorMessage: string) {
        if (errorPopupComponent) {
            let element = errorPopupComponent.element();
            errorPopupComponent.dispose();
            element.remove();
        }

        let popupOptions = {
            contentTemplate: () => {
                const scrollView = $('<div />');
                scrollView.append($('<div id="textBlock" />').html(errorMessage));
                scrollView.dxScrollView({
                    width: '100%',
                    height: '100%',
                });

                return scrollView;
            },
            width: 500,
            height: 200,
            showTitle: true,
            title: 'Error sending the Email',
            hideOnOutsideClick: true,
            showCloseButton: true,
            toolbarItems: [{
                widget: 'dxButton',
                toolbar: 'bottom',
                location: 'after',
                options: {
                    text: 'Close',
                    onClick() {
                        errorPopupComponent.hide();
                    }
                }
            }],
            onInitialized(e) {
                errorPopupComponent = e.component;
                errorPopupComponent.show();
            }
        } as DevExpress.ui.dxPopup.Properties;

        let $popover = $(`<div data-bind="dxPopup: popupOptions"></div>`);
        $popover.appendTo('body');

        ko.applyBindings({ popupOptions }, $popover[0]);
    }
}